import { XMasonry, XBlock } from 'react-xmasonry';
import { GetOnBoarding } from 'api/training';
import LoadingIndicator from 'components/Global/loading-indicator/loading-indicator';
import { StrikeThroughHeader } from 'components/Headers/strikethrough-header/strikethrough-header';
import '../Index/Index.scss';
import { useQuery } from '@tanstack/react-query';
import CategoryAccordion from '../../../components/Cards/card/CategoryAccordion';

export default function Onboarding({ categorizeArray, RetryView }) {
  const { data, isPending, isError, refetch } = useQuery({
    queryKey: ['getOnBoarding'],
    queryFn: () => GetOnBoarding()(),
  });
  const categorizedData = data ? categorizeArray(JSON.parse(data)) : [];

  return (
    <>
      <StrikeThroughHeader>Onboarding</StrikeThroughHeader>
      <div className="page-inner-content">
        {isPending && <LoadingIndicator />}
        {isError && <RetryView message="Failed to load Onboarding Items" callback={refetch} />}
        {!isPending && !isError && (
          <XMasonry maxColumns={3} responsive targetBlockWidth={500}>
            {categorizedData.map((category, index) => (
              <XBlock key={category.name}>
                <CategoryAccordion
                  key={category.name}
                  category={category}
                  index={index}
                  baseUrl={`${process.env.REACT_APP_AGENTPORTAL_PREFIX}/OnBoarding`}
                />
              </XBlock>
            ))}
          </XMasonry>
        )}
      </div>
    </>
  );
}
